export const checkCookieIsEnabled = () => {
  return navigator.cookieEnabled;
};
